module.exports = new __parcel__URL__("ask-iwata.964d26a0.jpg").toString();